import { useQuery } from '@tanstack/react-query';

import REACT_QUERY_KEYS_REVIEWS_INSIGHTS from '../constants/reactQueryKeysReviewsInsights';
import getTrendLineChartData from '../services';

const useReviewTrendLineChartData = ({ cohort }) =>
  useQuery(
    [REACT_QUERY_KEYS_REVIEWS_INSIGHTS.reviewsTendLineChart, cohort?.id],
    () =>
      getTrendLineChartData({
        cohort: {
          id: cohort.id,
          name: cohort.name,
          type: cohort.type,
        },
      }),
    {
      enabled: !!cohort,
    }
  );

export default useReviewTrendLineChartData;
